// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vB9T","textarea":"styles_textarea__sixvL"};